import React from 'react'

import { HStack } from '~/components/elements/HStack'
import { Operator } from '~/components/elements/Operator'
import { OperatorContainer } from '~/components/elements/OperatorContainer'
import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'
import { exists, type FilterText } from '~/utils'

import styles from './RichFilterGroupsDisplay.css'

export type RichFilterGroupsDisplayProps = {
  'data-testid'?: string
  filterTextGroups: FilterText[][]
}

export const RichFilterGroupsDisplay = ({
  'data-testid': dataTestId = 'components-features-rich-filter-groups-display',
  filterTextGroups,
}: RichFilterGroupsDisplayProps) => (
  <VStack data-testid={dataTestId} spacing={4}>
    {filterTextGroups.map((filterTextGroup, filterTextGroupIndex) => (
      <React.Fragment key={filterTextGroupIndex}>
        {filterTextGroupIndex !== 0 && (
          <Operator className={styles.operator} operator="OR" size={80} />
        )}

        <VStack spacing={2}>
          {filterTextGroup.map(({ name, subName, values }, filterTextIndex) => (
            <OperatorContainer
              key={filterTextIndex}
              operator={filterTextIndex !== 0 ? 'AND' : null}
              size={80}
            >
              <VStack className={styles.container} padding={[4, 2]} spacing={2}>
                <Typography variant="normal">
                  {[name, subName].filter(exists).join(' ')}
                </Typography>

                <HStack spacing={1} wrap={true}>
                  {values.map((value) => (
                    <Typography key={value} variant="normal">
                      <span className={styles.value}>{value}</span>
                    </Typography>
                  ))}
                </HStack>
              </VStack>
            </OperatorContainer>
          ))}
        </VStack>
      </React.Fragment>
    ))}
  </VStack>
)
